var render = function render() {
  var _vm$data$ledgersItemW, _vm$data$ledgersItemW2;
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "app-container"
  }, [_vm.data ? _c("el-descriptions", {
    attrs: {
      title: "Ledger Details",
      border: "",
      "label-style": {
        "font-weight": "bold"
      }
    }
  }, [_c("el-descriptions-item", {
    attrs: {
      label: "Ledger ID"
    }
  }, [_vm._v(" " + _vm._s(_vm.data.id) + " ")]), _c("el-descriptions-item", {
    attrs: {
      label: "Narration"
    }
  }, [_vm._v(" " + _vm._s(_vm.data.comments) + " ")]), _c("el-descriptions-item", {
    attrs: {
      label: "Taxed amount"
    }
  }, [_c("inr", {
    attrs: {
      number: _vm.data.taxedAmount
    }
  })], 1), _c("el-descriptions-item", {
    attrs: {
      label: "Status"
    }
  }, [_vm._v(" " + _vm._s(_vm.data.status) + " ")]), _c("el-descriptions-item", {
    attrs: {
      label: "Payment Type"
    }
  }, [_vm._v(" " + _vm._s(_vm.data.paymentType) + " ")]), _c("el-descriptions-item", {
    attrs: {
      label: "Payment Sub Type"
    }
  }, [_vm._v(" " + _vm._s((_vm$data$ledgersItemW = (_vm$data$ledgersItemW2 = _vm.data.ledgersItemWise[0]) === null || _vm$data$ledgersItemW2 === void 0 ? void 0 : _vm$data$ledgersItemW2.paymentSubType) !== null && _vm$data$ledgersItemW !== void 0 ? _vm$data$ledgersItemW : "N/A") + " ")]), _c("el-descriptions-item", {
    attrs: {
      label: "Created On",
      span: 2
    }
  }, [_c("span", [_vm._v(" " + _vm._s(_vm._f("moment")(_vm.data.createdTimestamp, "DD-MM-YYYY hh:mm a")) + " ")])]), _c("el-descriptions-item", {
    attrs: {
      label: "Total Number of Products"
    }
  }, [_vm._v(" " + _vm._s(_vm.data.CnDnProducts.length) + " ")]), _c("el-descriptions-item", {
    attrs: {
      label: "Amount"
    }
  }, [_c("inr", {
    attrs: {
      number: _vm.data.amount
    }
  })], 1)], 1) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };